import {receiveGameInfo} from "./actions";
import api from './../../api';

export const fetchGameInfo = gameId => dispatch => (
    api.gameInfo.fetch(null, {pk: gameId})
        .then((response) => {
            dispatch(receiveGameInfo(response));
        }).catch((response) => {
            console.error(response); // eslint-disable-line no-console
        })
);

export const postResult = (basketId, teamId, result, teamOb) => () => {
    // Make sure ob isn't null
    const ob = teamOb || 0;
    if (result === null) {
        return;
    }

    const payload = {
        result,
        ob,
        team: {
            id: teamId,
        },
        basket: {
            id: basketId,
        },
    };

    api.results.post(null, payload).then().catch((resp) => {
        console.error(resp); // eslint-disable-line no-console
    });
};

export const finishGame = gameId => () => {
    const payload = {game: gameId};

    api.finishGame.post(null, payload).then(() => {
        window.location.href = `${DJ_CONST.SITE_URL}/game/detail/${gameId}/`;
    }).catch((resp) => {
        console.error(resp); // eslint-disable-line no-console
    });
};



// WEBPACK FOOTER //
// ./src/apps/result_entry/thunkActions.js